import { type QueryClient } from '@tanstack/react-query';
import { getShopQueryKey } from '@pkgs/components/hooks/queries/queryKeys';
import { type GenericExposeListing, type MasterDataShopResponse } from '@pkgs/api';

import { getShopIdFromPageContext } from './getShopIdFromPageContext';

type GetShopFromQueryCacheParams = {
  queryClient: QueryClient;
  listing?: GenericExposeListing;
};

export const getShopFromQueryCache = ({ queryClient, listing }: GetShopFromQueryCacheParams): MasterDataShopResponse | undefined => {
  const shopId = getShopIdFromPageContext({ listing });
  if (!shopId) return undefined;

  return queryClient.getQueryData<MasterDataShopResponse>(getShopQueryKey({ shopId }));
};
